import React from 'react';

import './index.scss';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import iconUsuarios from '../../../../assets/images/icon_usuarios.svg';

export default (props) => {
  const { i18n } = useTranslation();

  const { icon, label, active, showActiveIcon, href, type } = props;

  return (
    <div className={type === 'config' ? 'channel-card-config' : 'channel-card'}>
      {showActiveIcon ? (
        <div className={`active ${active ? '' : 'inactive'}`} />
      ) : null}
      <div className="d-flex justify-content-center">
        <img src={icon || iconUsuarios} alt="" />
      </div>
      <span className="d-flex justify-content-center mt-5">
        {label || 'WhatsApp'}
      </span>
      <div className="mt-3 d-flex justify-content-center">
        <Link to={href}>{i18n.t('Configurar')}</Link>
      </div>
    </div>
  );
};
